import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "analysis-reference-embed" }
const _hoisted_2 = {
  key: 0,
  class: "embed-state"
}
const _hoisted_3 = {
  key: 1,
  class: "embed-state is-error"
}
const _hoisted_4 = {
  key: 2,
  class: "aar"
}
const _hoisted_5 = { class: "aar-summary" }
const _hoisted_6 = { class: "aar-card is-income" }
const _hoisted_7 = { class: "aar-card-count" }
const _hoisted_8 = { class: "aar-card is-expense" }
const _hoisted_9 = { class: "aar-card-count" }
const _hoisted_10 = { class: "aar-card" }
const _hoisted_11 = { class: "aar-card-count" }
const _hoisted_12 = { class: "aar-labor-badge" }
const _hoisted_13 = { class: "aar-body" }
const _hoisted_14 = {
  class: "aar-toc",
  "aria-label": "계정 목록"
}
const _hoisted_15 = { class: "aar-toc-head" }
const _hoisted_16 = { class: "aar-toc-list" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "aar-toc-name" }
const _hoisted_19 = { class: "aar-toc-amt" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "aar-toc-name" }
const _hoisted_22 = { class: "aar-toc-amt" }
const _hoisted_23 = {
  key: 2,
  class: "aar-toc-empty"
}
const _hoisted_24 = {
  key: 0,
  id: "sec-labor",
  class: "aar-labor-detail"
}
const _hoisted_25 = { class: "aar-acc-body" }
const _hoisted_26 = { class: "aar-note" }
const _hoisted_27 = { class: "aar-steps" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "aar-sub"
}
const _hoisted_30 = { class: "aar-table" }
const _hoisted_31 = { class: "num" }
const _hoisted_32 = { class: "num" }
const _hoisted_33 = { class: "num" }
const _hoisted_34 = { class: "num" }
const _hoisted_35 = {
  key: 1,
  class: "aar-sub"
}
const _hoisted_36 = { class: "aar-table" }
const _hoisted_37 = { class: "num" }
const _hoisted_38 = { class: "num" }
const _hoisted_39 = { class: "num" }
const _hoisted_40 = { class: "aar-note" }
const _hoisted_41 = { class: "aar-sub" }
const _hoisted_42 = { class: "aar-note" }
const _hoisted_43 = {
  key: 0,
  class: "aar-table"
}
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "num" }
const _hoisted_47 = { class: "num" }
const _hoisted_48 = ["id"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = { class: "aar-acc-title" }
const _hoisted_51 = {
  key: 0,
  class: "aar-acc-code"
}
const _hoisted_52 = { class: "aar-acc-meta" }
const _hoisted_53 = { class: "aar-acc-amount" }
const _hoisted_54 = { class: "aar-acc-body" }
const _hoisted_55 = {
  key: 0,
  class: "aar-table"
}
const _hoisted_56 = { class: "num" }
const _hoisted_57 = { class: "nowrap" }
const _hoisted_58 = { class: "memo" }
const _hoisted_59 = { class: "num" }
const _hoisted_60 = {
  key: 1,
  class: "aar-empty"
}
const _hoisted_61 = {
  key: 1,
  class: "aar-empty is-page"
}

import { computed, ref, watch, nextTick } from 'vue';
import { bankbookApi } from '@/services/api';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountingAnalysisReferenceEmbed',
  props: {
    memberCode: {},
    year: {},
    month: {},
    bizGubun: {},
    bankCode: {}
  },
  setup(__props: any) {

const props = __props;

const loading = ref(false);
const error = ref('');
const data = ref<any>(null);

const expandedIds = ref<Set<string>>(new Set());
const tocFilter = ref('');
const docRef = ref<HTMLElement | null>(null);

const formatWon = (value: number | null | undefined): string => {
  if (value == null || !Number.isFinite(Number(value))) return '-';
  return `${Math.round(Number(value)).toLocaleString('ko-KR')}원`;
};

const accounts = computed<any[]>(() => data.value?.accounts || []);
const incomeAccounts = computed(() => accounts.value.filter((a) => a.gubun === 'IN'));
const expenseAccounts = computed(() => accounts.value.filter((a) => a.gubun === 'OUT'));

const filteredIncome = computed(() =>
  incomeAccounts.value.filter((a) => !tocFilter.value || String(a.sname).includes(tocFilter.value))
);
const filteredExpense = computed(() =>
  expenseAccounts.value.filter((a) => !tocFilter.value || String(a.sname).includes(tocFilter.value))
);

const balance = computed(() =>
  Number(data.value?.summary?.incomeTotal || 0) - Number(data.value?.summary?.expenseTotal || 0)
);

const periodLabel = computed(() =>
  data.value?.periodRange || data.value?.periodLabel || ''
);

const laborRatioText = computed(() => {
  const d = data.value?.laborRatioDetail;
  if (!d) return '-';
  return d.ratio != null ? `${d.ratio}%` : '계산불가';
});

// 전체 섹션 id (인건비 + 계정들)
const allSectionIds = computed<string[]>(() => {
  const ids: string[] = [];
  if (data.value?.laborRatioDetail) ids.push('labor');
  accounts.value.forEach((acc) => ids.push(acc.id));
  return ids;
});

const allExpanded = computed(() =>
  allSectionIds.value.length > 0 && allSectionIds.value.every((id) => expandedIds.value.has(id))
);

const isExpanded = (id: string) => expandedIds.value.has(id);

const setExpanded = (id: string, on: boolean) => {
  const next = new Set(expandedIds.value);
  if (on) next.add(id);
  else next.delete(id);
  expandedIds.value = next;
};

const toggleExpand = (id: string) => {
  setExpanded(id, !isExpanded(id));
};

const scrollTo = async (id: string) => {
  setExpanded(id, true); // 목차에서 누르면 펼치고 스크롤 (다른 섹션 상태 유지)
  await nextTick();
  const el = docRef.value?.querySelector(`#sec-${id}`);
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const expandAll = () => {
  expandedIds.value = new Set(allSectionIds.value);
};

const collapseAll = () => {
  expandedIds.value = new Set();
};

const toggleAll = () => {
  if (allExpanded.value) collapseAll();
  else expandAll();
};

const load = async () => {
  if (!props.memberCode || !props.year || !props.month) return;
  loading.value = true;
  error.value = '';
  data.value = null;
  tocFilter.value = '';
  try {
    const monthNum = parseInt(String(props.month), 10);
    const response = await bankbookApi.getAccountingAnalysisReference(
      String(props.memberCode),
      {
        year: String(props.year),
        month: String(monthNum),
        bizGubun: props.bizGubun || undefined,
        bankCode: props.bankCode || undefined,
        periodType: 'month',
        startMonth: monthNum,
        endMonth: monthNum,
      }
    );
    const result = response.data?.data;
    if (!result) {
      error.value = '계정별내역 데이터가 없습니다.';
      return;
    }
    data.value = result;
    // 기본: 모두 펼친 상태
    const ids: string[] = [];
    if (result.laborRatioDetail) ids.push('labor');
    (result.accounts || []).forEach((acc: any) => ids.push(acc.id));
    expandedIds.value = new Set(ids);
  } catch (err: any) {
    error.value = err.response?.data?.message || err.message || '계정별내역 조회 실패';
  } finally {
    loading.value = false;
  }
};

watch(
  () => [props.memberCode, props.year, props.month, props.bizGubun, props.bankCode],
  () => { load(); },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "#1e3a5f",
            size: "36"
          }),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "계정별내역 불러오는 중...", -1))
        ]))
      : (error.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("p", null, _toDisplayString(error.value), 1),
            _createElementVNode("button", {
              type: "button",
              class: "embed-retry",
              onClick: load
            }, "다시 시도")
          ]))
        : (data.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[22] || (_cache[22] = _createStaticVNode("<div class=\"aar-guide\"><div class=\"aar-guide-row\"><span class=\"aar-guide-label\">이 화면은</span><p>이 달 통장내역을 <strong>계정과목별로 묶어</strong> 얼마 들어오고 나갔는지 보여주는 <strong>조회 전용</strong> 화면입니다. 여기서 수정하지 않고, 정리한 결과를 확인만 합니다.</p></div><div class=\"aar-guide-row\"><span class=\"aar-guide-label\">쓰이는 곳</span><p>월 마감 전 수입·지출 검토 · 계정별 합계 확인 · 인건비지출비율 점검</p></div></div>", 1)),
              _createElementVNode("header", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "aar-card-label" }, "수입", -1)),
                  _createElementVNode("strong", null, _toDisplayString(formatWon(data.value.summary?.incomeTotal)), 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString((data.value.summary?.income || []).length) + "개 계정", 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "aar-card-label" }, "지출", -1)),
                  _createElementVNode("strong", null, _toDisplayString(formatWon(data.value.summary?.expenseTotal)), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString((data.value.summary?.expense || []).length) + "개 계정", 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "aar-card-label" }, "수입 − 지출", -1)),
                  _createElementVNode("strong", null, _toDisplayString(formatWon(balance.value)), 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(periodLabel.value), 1)
                ]),
                (data.value.laborRatioDetail)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["aar-labor", data.value.laborRatioDetail.met ? 'is-ok' : 'is-warn']),
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (scrollTo('labor')))
                    }, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", { class: "aar-card-label" }, "인건비지출비율", -1)),
                      _createElementVNode("strong", null, _toDisplayString(laborRatioText.value), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(data.value.laborRatioDetail.met ? '충족' : '미충족'), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("aside", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tocFilter).value = $event)),
                      type: "text",
                      class: "aar-toc-search",
                      placeholder: "계정 검색"
                    }, null, 512), [
                      [_vModelText, tocFilter.value]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "aar-toc-toggle",
                      onClick: toggleAll
                    }, _toDisplayString(allExpanded.value ? '모두 접기' : '모두 펼치기'), 1)
                  ]),
                  _createElementVNode("nav", _hoisted_16, [
                    (filteredIncome.value.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[8] || (_cache[8] = _createElementVNode("p", { class: "aar-toc-group" }, "수입", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredIncome.value, (acc) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: acc.id,
                              type: "button",
                              class: _normalizeClass(["aar-toc-item", { active: isExpanded(acc.id) }]),
                              onClick: ($event: any) => (scrollTo(acc.id))
                            }, [
                              _createElementVNode("span", _hoisted_18, _toDisplayString(acc.sname), 1),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(formatWon(acc.amount)), 1)
                            ], 10, _hoisted_17))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true),
                    (filteredExpense.value.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "aar-toc-group" }, "지출", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredExpense.value, (acc) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: acc.id,
                              type: "button",
                              class: _normalizeClass(["aar-toc-item", { active: isExpanded(acc.id) }]),
                              onClick: ($event: any) => (scrollTo(acc.id))
                            }, [
                              _createElementVNode("span", _hoisted_21, _toDisplayString(acc.sname), 1),
                              _createElementVNode("span", _hoisted_22, _toDisplayString(formatWon(acc.amount)), 1)
                            ], 10, _hoisted_20))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true),
                    (!filteredIncome.value.length && !filteredExpense.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, " 검색 결과 없음 "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("main", {
                  ref_key: "docRef",
                  ref: docRef,
                  class: "aar-doc"
                }, [
                  (data.value.laborRatioDetail)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "aar-acc-head",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleExpand('labor')))
                        }, [
                          _createVNode(_component_v_icon, {
                            size: "18",
                            class: _normalizeClass(["aar-chevron", { open: isExpanded('labor') }])
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode(" mdi-chevron-down ", -1)
                            ]))]),
                            _: 1
                          }, 8, ["class"]),
                          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "aar-acc-title" }, "인건비지출비율", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass(["aar-acc-amount", data.value.laborRatioDetail.met ? 'ok' : 'warn'])
                          }, _toDisplayString(data.value.laborRatioDetail.met ? '충족' : '미충족') + " · 기준 " + _toDisplayString(data.value.laborRatioDetail.requiredPercent) + "% ", 3)
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_25, [
                          _createElementVNode("p", _hoisted_26, _toDisplayString(data.value.laborRatioDetail.formula), 1),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.laborRatioDetail.steps || [], (step) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: step.key,
                                class: _normalizeClass(["aar-step", { warn: step.warn }])
                              }, [
                                _createElementVNode("span", null, [
                                  _createTextVNode(_toDisplayString(step.label), 1),
                                  (step.hint)
                                    ? (_openBlock(), _createElementBlock("em", _hoisted_28, " · " + _toDisplayString(step.hint), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("strong", null, _toDisplayString(step.text != null ? step.text : formatWon(step.amount)), 1)
                              ], 2))
                            }), 128))
                          ]),
                          ((data.value.laborRatioDetail.monthlyRows || []).length)
                            ? (_openBlock(), _createElementBlock("details", _hoisted_29, [
                                _cache[13] || (_cache[13] = _createElementVNode("summary", null, "월별 추이 (당월 · 누적)", -1)),
                                _createElementVNode("table", _hoisted_30, [
                                  _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", null, "월"),
                                      _createElementVNode("th", { class: "num" }, "당월 수입"),
                                      _createElementVNode("th", { class: "num" }, "당월 지출"),
                                      _createElementVNode("th", { class: "num" }, "당월 비율"),
                                      _createElementVNode("th", { class: "num" }, "누적 비율")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.laborRatioDetail.monthlyRows, (row) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: row.month,
                                        class: _normalizeClass({ 'is-bad': row.cumMet === false })
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(row.label), 1),
                                        _createElementVNode("td", _hoisted_31, _toDisplayString(formatWon(row.income)), 1),
                                        _createElementVNode("td", _hoisted_32, _toDisplayString(formatWon(row.expense)), 1),
                                        _createElementVNode("td", _hoisted_33, _toDisplayString(row.monthRatio != null ? row.monthRatio + '%' : '-'), 1),
                                        _createElementVNode("td", _hoisted_34, _toDisplayString(row.cumRatio != null ? row.cumRatio + '%' : '-'), 1)
                                      ], 2))
                                    }), 128))
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (data.value.laborRatioDetail.expense?.fromWage && (data.value.laborRatioDetail.expense.wageRows || []).length)
                            ? (_openBlock(), _createElementBlock("details", _hoisted_35, [
                                _cache[15] || (_cache[15] = _createElementVNode("summary", null, "인건비지출 구성 (임금자료)", -1)),
                                _createElementVNode("table", _hoisted_36, [
                                  _cache[14] || (_cache[14] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", null, "연월"),
                                      _createElementVNode("th", null, "사업구분"),
                                      _createElementVNode("th", { class: "num" }, "인건비"),
                                      _createElementVNode("th", { class: "num" }, "인건비가산"),
                                      _createElementVNode("th", { class: "num" }, "합계")
                                    ])
                                  ], -1)),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.laborRatioDetail.expense.wageRows, (row, i) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                        _createElementVNode("td", null, _toDisplayString(row.label || row.yearMonth), 1),
                                        _createElementVNode("td", null, _toDisplayString(row.bizGubun || '-'), 1),
                                        _createElementVNode("td", _hoisted_37, _toDisplayString(formatWon(row.laborCost)), 1),
                                        _createElementVNode("td", _hoisted_38, _toDisplayString(formatWon(row.laborAdd)), 1),
                                        _createElementVNode("td", _hoisted_39, _toDisplayString(formatWon(row.amount)), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("p", _hoisted_40, " 인건비 " + _toDisplayString(formatWon(data.value.laborRatioDetail.expense.wageCostTotal)) + " + 인건비가산 " + _toDisplayString(formatWon(data.value.laborRatioDetail.expense.wageAddTotal)) + " = " + _toDisplayString(formatWon(data.value.laborRatioDetail.expense.wageTotal)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("details", _hoisted_41, [
                            _createElementVNode("summary", null, "인건비수입 구성 · " + _toDisplayString(formatWon(data.value.laborRatioDetail.income?.total)), 1),
                            _createElementVNode("p", _hoisted_42, _toDisplayString(data.value.laborRatioDetail.income?.note), 1),
                            ((data.value.laborRatioDetail.income?.groups || []).length)
                              ? (_openBlock(), _createElementBlock("table", _hoisted_43, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      (data.value.showAccountCodes)
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_44, "코드"))
                                        : _createCommentVNode("", true),
                                      _cache[16] || (_cache[16] = _createElementVNode("th", null, "계정", -1)),
                                      _cache[17] || (_cache[17] = _createElementVNode("th", { class: "num" }, "합계", -1)),
                                      _cache[18] || (_cache[18] = _createElementVNode("th", { class: "num" }, "건수", -1))
                                    ])
                                  ]),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.laborRatioDetail.income.groups, (g, i) => {
                                      return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                        (data.value.showAccountCodes)
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_45, _toDisplayString(g.scode || '-'), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("td", null, _toDisplayString(g.sname), 1),
                                        _createElementVNode("td", _hoisted_46, _toDisplayString(formatWon(g.amount)), 1),
                                        _createElementVNode("td", _hoisted_47, _toDisplayString(g.count), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ], 512), [
                          [_vShow, isExpanded('labor')]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value, (acc) => {
                    return (_openBlock(), _createElementBlock("section", {
                      id: `sec-${acc.id}`,
                      key: acc.id,
                      class: "aar-acc"
                    }, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "aar-acc-head",
                        onClick: ($event: any) => (toggleExpand(acc.id))
                      }, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          class: _normalizeClass(["aar-chevron", { open: isExpanded(acc.id) }])
                        }, {
                          default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                            _createTextVNode(" mdi-chevron-down ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["class"]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["aar-acc-gubun", acc.gubun === 'IN' ? 'is-income' : 'is-expense'])
                        }, _toDisplayString(acc.gubunLabel), 3),
                        _createElementVNode("span", _hoisted_50, [
                          (data.value.showAccountCodes && acc.scode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_51, _toDisplayString(acc.scode), 1))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(acc.sname), 1)
                        ]),
                        _createElementVNode("span", _hoisted_52, _toDisplayString(acc.count) + "건", 1),
                        _createElementVNode("span", _hoisted_53, _toDisplayString(formatWon(acc.amount)), 1)
                      ], 8, _hoisted_49),
                      _withDirectives(_createElementVNode("div", _hoisted_54, [
                        ((acc.entries || []).length)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_55, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _cache[20] || (_cache[20] = _createElementVNode("th", null, "일자", -1)),
                                  _cache[21] || (_cache[21] = _createElementVNode("th", null, "적요", -1)),
                                  _createElementVNode("th", _hoisted_56, _toDisplayString(acc.gubun === 'IN' ? '수입' : '지출'), 1)
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(acc.entries, (entry, i) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                    _createElementVNode("td", _hoisted_57, _toDisplayString(entry.date || '-'), 1),
                                    _createElementVNode("td", _hoisted_58, _toDisplayString(entry.memo || ''), 1),
                                    _createElementVNode("td", _hoisted_59, _toDisplayString(formatWon(acc.gubun === 'IN' ? (entry.income ?? entry.amount) : (entry.expense ?? entry.amount))), 1)
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_60, "해당 계정 내역 없음"))
                      ], 512), [
                        [_vShow, isExpanded(acc.id)]
                      ])
                    ], 8, _hoisted_48))
                  }), 128)),
                  (!accounts.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_61, "조회된 계정 내역이 없습니다."))
                    : _createCommentVNode("", true)
                ], 512)
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}
}

})